import React from "react"
import { Confirm } from "../../../../../Common/Modal/Confirm"
import { useAsyncCommand } from "../../../../../../Hooks/useAsyncCommand"

interface DeleteModalProps {
    total: number
    onYes: () => Promise<void>
    onNo: () => void
}

export function DeleteModal({ total, onNo, onYes }: DeleteModalProps) {
    const { perform, isProcessing } = useAsyncCommand(onYes)

    return (
        <Confirm
            title={`Delete ${total} data point${total > 1 ? "s" : ""}?`}
            description="This action cannot be undone and will delete all versions."
            yesLabel={isProcessing ? "Deleting..." : `Delete ${total} forever`}
            isProcessing={isProcessing}
            onClickYes={perform}
            onClose={onNo}
        />
    )
}
